import { FormPath, isField, type Form } from "@formily/core";
import { useField, useForm } from "@formily/react";
import { useEffect } from "react";

/**
 * This isn't particularly flexible, but used in editable tables
 */
export const getModifiedTopLevelValues = <T extends object>(values: T, form: Form<T>): T => {
  return Object.fromEntries(Object.entries(values).filter(([key]) => form.getFieldState(key).modified)) as T;
};

export const useInitialValueSync = (name: string | number | RegExp, initialValue: unknown) => {
  const form = useForm();
  const parent = useField();
  const address = FormPath.parse(parent.address).concat(name);
  useEffect(() => {
    form.query(address).forEach((field) => {
      if (!isField(field)) return;
      if (field.initialValue !== initialValue) {
        field.setInitialValue(initialValue);
      }
    });
  }, [form, initialValue, address]);
};
